<div class="badge"
     [class.mobile]="deviceService.isMobile()"
     [class.warning]="isOnModeration"
     [class.error]="isDeclined">

  <ng-container *ngIf="isOnModeration">
    <loading-game [size]="20" class="icon"></loading-game>
    <p class="title">{{ 'collections.moderation-status.on-moderation' | customLocale }}...</p>
  </ng-container>

  <ng-container *ngIf="isDeclined">
    <p class="title">{{ (type === 'service' ? 'library.user-service-card.status.declined' : 'collections.moderation-status.fail') | customLocale }}{{reason ? ' - ' + reason : ''}}</p>
  </ng-container>
</div>
